import { axiosInstance } from './config/instance'
import { CONSOLE_API_URL, SERVER } from './config/url'

const USERS_URL = `${SERVER}/${CONSOLE_API_URL}`
const ENTITY = 'users'

export const users = Object.freeze({
  async fetchUserById(id) {
    const response = await axiosInstance.get(`${USERS_URL}/${ENTITY}/${id}`)
    return response.data
  },
  async fetchUserList(data) {
    const response = await axiosInstance.post(`${USERS_URL}/${ENTITY}/search`, data)
    return response.data
  },
  async setUserEnable(id, data) {
    const response = await axiosInstance.post(`${USERS_URL}/${ENTITY}/${id}/enable`, data)
    return response.data
  },
  async setUserDisable(id, data) {
    const response = await axiosInstance.post(`${USERS_URL}/${ENTITY}/${id}/disable`, data)
    return response.data
  },
  async removeUser(id, data) {
    const response = await axiosInstance.post(`${USERS_URL}/${ENTITY}/${id}/deleteUser`, data)
    return response.data
  },
  async updateUser(id, data, params) {
    const response = await axiosInstance.put(`${USERS_URL}/${ENTITY}/${id}`, data, {
      params,
    })
    return response.data
  },
  async syncUser(id) {
    const response = await axiosInstance.get(`${USERS_URL}/${ENTITY}/sync/${id}`)
    return response.data
  },
  async updateUserInternal(id, data) {
    const response = await axiosInstance.put(`${USERS_URL}/${ENTITY}/edit/${id}`, data)
    return response.data
  },
  async fetchUserBalance(id, data) {
    const response = await axiosInstance.post(`${USERS_URL}/${ENTITY}/${id}/balance`, data)
    return response.data
  },
  async setUserTrusted(id, data) {
    const response = await axiosInstance.post(`${USERS_URL}/${ENTITY}/${id}/trusted`, data)
    return response.data
  },
  async setUserUntrusted(id, data) {
    const response = await axiosInstance.post(`${USERS_URL}/${ENTITY}/${id}/untrusted`, data)
    return response.data
  },
  async getAccountsInfo(id, data) {
    const response = await axiosInstance.post(`${USERS_URL}/${ENTITY}/${id}/accounts`, data)
    return response.data
  },
  async clearTransactionsCache(id) {
    const response = await axiosInstance.get(`${USERS_URL}/${ENTITY}/clearcache/${id}`)
    return response.data
  },
  async fetchEkengById(id) {
    const response = await axiosInstance.get(`${USERS_URL}/${ENTITY}/ekeng/data/${id}`)
    return response.data
  },
  async updateEkeng(id) {
    const response = await axiosInstance.get(`${USERS_URL}/${ENTITY}/ekeng/refresh/${id}`)
    return response.data
  },
  async enableIDX(id) {
    const response = await axiosInstance.get(`${USERS_URL}/${ENTITY}/${id}/enableIdx`)
    return response.data
  },
  async disableIDX(id) {
    const response = await axiosInstance.get(`${USERS_URL}/${ENTITY}/${id}/disableIdx`)
    return response.data
  },
  async fetchIncomingTransfers(id, data) {
    const response = await axiosInstance.post(
      `${USERS_URL}/${ENTITY}/${id}/idbankIncomingTransfers`,
      data
    )
    return response.data
  },
  async fetchUserListBySovcomClientId(id) {
    if (id) {
      const response = await axiosInstance.get(`${USERS_URL}/${ENTITY}/search/bySovcomClientId/${id}`)
      return response.data
    }
  },
})